import React from "react";
import { Container, Row } from "react-bootstrap";
import SingleTeacher from "./SingleTeacher";
import teacher1 from "../../../../img/pt/pt01.jpg"
import teacher2 from "../../../../img/pt/pt02.jpg"
import teacher3 from "../../../../img/pt/pt03.jpg"


const Teachers = () => {
  const teachers=[
    {id:1,
      name:'Vannessa Willis',
      title:"Meditation Trainer",
      img:teacher1
    },
    {id:2,
      name:'Yvone Wright',
      title:"Yoga Trainer",
      img:teacher2
    },

    {id:3,
      name:'Bruce Palmer',
      title:"Fitness Trainer",
      img:teacher3
    },


  ]
  return (
    <div style={{overflow:"hidden"}}>
      <svg
        style={{ fill: "#D6ECE1", width: "145%", transform: "rotate(180deg)",marginBottom:'-2px' }}
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
      </svg>
      <Container fluid className="teacher-section">
        <Container className="py-5">
          <Row>
          <div className="teachers-title text-center">
            <h3 className="trainer-section-title1">Teachers</h3>
            <h2 className="trainer-section-title2">
              {" "}
              Practice With Confidence
            </h2>
          </div>
          </Row>
          <Row className="mt-5">
        {
          teachers.map(teacher=><SingleTeacher key={teacher.id} data={teacher}></SingleTeacher>)
        }
          </Row>

        </Container>
      </Container>
    </div>
  );
};

export default Teachers;
